'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('./utils'),
    isValidMultiaddr = _require.isValidMultiaddr;

var _require2 = require('../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

module.exports = function (_ref) {
  var repo = _ref.repo;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _rm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(multiaddr, options) {
      var res, config;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};

              if (!(multiaddr && !isValidMultiaddr(multiaddr))) {
                _context.next = 3;
                break;
              }

              throw new Error("".concat(multiaddr, " is not a valid Multiaddr"));

            case 3:
              res = [];
              _context.next = 6;
              return repo.config.get();

            case 6:
              config = _context.sent;

              if (options.all) {
                res = config.Bootstrap || [];
                config.Bootstrap = [];
              } else {
                config.Bootstrap = (config.Bootstrap || []).filter(function (ma) {
                  return ma !== multiaddr;
                });
              }

              _context.next = 10;
              return repo.config.set(config);

            case 10:
              if (!options.all && multiaddr) {
                res.push(multiaddr);
              }

              return _context.abrupt("return", {
                Peers: res
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function rm(_x, _x2) {
      return _rm.apply(this, arguments);
    }

    return rm;
  }());
};